import styled, { css } from 'styled-components';

export const BadgeSC = styled.div<{
  /**
   * Position badge on chosen side of component
   */
  positionHorizontal?: 'left' | 'right';
  /**
   * Position badge on chosen side of component
   */
  positionVertical?: 'top' | 'bottom';
  standalone?: boolean;
}>`
  ${({ standalone, positionHorizontal, positionVertical }) => {
    if (!standalone) {
      return css`
        position: absolute;
        z-index: 999;

        ${positionHorizontal === 'right' ? 'right: -8px;' : 'left: -8px;'}
        ${positionVertical === 'top' ? 'top: -8px;' : 'bottom: -8px;'}
      `;
    }
  }}

  align-items: center;
  justify-content: center;
  border-radius: 9999px;
`;

export const BadgeContent = styled.div<{ count: number }>`
  padding-top: 1.5px;

  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;

  font-weight: 700;
  font-size: 10px;
  line-height: 10px;

  ${({ count }) => {
    let size;

    if (count < 10) {
      size = 20;
    } else if (count < 99) {
      size = 20;
    } else {
      size = 25;
    }

    return css`
      min-width: ${size}px;
      min-height: ${size}px;
    `;
  }};

  background: ${({ theme }) =>
    `linear-gradient(125.55deg, ${theme.color.gradient.accent[0]} 21.04%, ${theme.color.gradient.accent[1]} 89.15%)`};
`;
